// extracted by mini-css-extract-plugin
export default {"question-icon--grey":"questionIcon_question-icon--grey__4zBgr","question-icon--purple":"questionIcon_question-icon--purple__m7quv"};